module.exports = "/packs/images/products/4-flavors-9dc959dc094929aa925a711de01833dc.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/4-flavors.png
// module id = 1776
// module chunks = 0